import React, { useEffect } from 'react'
import { Grid } from '@material-ui/core';
import {useSelector,useDispatch} from 'react-redux';
import Card1 from './Cards/Card1'
import Card2 from './Cards/Card2'
import Card3 from './Cards/Card3'
import Card4 from './Cards/Card4'
import Sidebar from './Sidebar'

function Home(props) {
    const dispatch = useDispatch();
    const reduxState = useSelector(state => state);

    return (
        <div>
            <Grid className="cards" container>
                        <Grid item className="card" xs={12} md={7}>
                            <h1 style={{ color: '#b32800', paddingLeft: '10px', marginTop: '-5px' }}>Recruiter Assessment</h1>
                            <div><Card1 uid={props.uid?props.uid :null} recruiters={props.booleanRecruiters} details={reduxState.info.info.quizDetails?.boolean} /></div>
                            <div><Card2 uid={props.uid?props.uid :null} recruiters={props.javaRecruiters} details={reduxState.info.info.quizDetails?.java} /></div>
                            <div><Card3 uid={props.uid?props.uid :null} recruiters={props.uiRecruiters} details={reduxState.info.info.quizDetails?.ui} /></div>
                            <div><Card4 uid={props.uid?props.uid :null} recruiters={props.devopsRecruiters} details={reduxState.info.info.quizDetails?.devops} /></div>
                        </Grid>
                <Grid item xs={12} md={5} className="side-bar">
                    <Sidebar />
                </Grid>
            </Grid>
        </div>
    )
};
export default Home